import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CreditReturnDetailsViewModel } from "../../viewmodels/creditReturns/CreditReturnDetailsViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import {
  withRouter,
  isReadOnlyUser,
  wipStatusOptions,
} from "../../shared/utility";

import EmptyModal from "../../components/modals/EmptyModal";
import TableLoadingSkeleton from "../../components/shared/TableLoadingSkeleton";
import { useParams } from "react-router-dom";
import CreditReturnCartonsTable from "./CreditReturnCartonsTable";
import Input from "../../components/controls/Input";
import ButtonDropdown from "../../components/controls/ButtonDropdown";
import OrderNotesModal from "../../components/forms/orders/OrderNotesModal";
import SelectMenu from "../../components/controls/SelectMenu";
import MediaUi from "../../components/importMedia/MediaUi";
import AuditActionLink from "../../components/audit/AuditActionLink";
import EmbeddedAuditHistory from "../../components/audit/EmbeddedAuditHistory";
import { getAuditApiEntityType } from "../../components/audit/auditEntityConfig";

function OrderDetails(props) {
  const { addSnackbar, logout } = props;

  const { creditReturnId } = useParams();
  const [pdf, setPdf] = useState(null);

  const {
    creditReturn,
    loading,
    emptyModal,
    setEmptyModelOpen,
    setCreditReturn,
    getCreditReturnDetails,
    onUpdateCreditNote,
    askDeleteCarton,
    getCustomersForDropdown,
    customers,
    onSaveCr,
    printCr,
    askDeleteCr,
    updateCreditReturnItem,
  } = CreditReturnDetailsViewModel(logout, creditReturnId, addSnackbar);

  useEffect(() => {
    getCreditReturnDetails();
    getCustomersForDropdown();
  }, []);

  const buttonOptions = [
    {
      name: "Print CR",
      onClick: printCr,
      inProgress: false,
    },
  ];
  const isReadOnly = isReadOnlyUser();
  return (
    <div>
      <div className="mt-2 px-4 sm:px-8">
        <div className="sm:items-center">
          <div className="sm:flex-auto flex items-center">
            <h1 className="text-xl font-semibold leading-6 text-gray-900">
              CR: {creditReturn.name}
            </h1>
            {creditReturnId ? (
              <AuditActionLink
                slug="credit-return"
                id={creditReturnId}
                name={creditReturn.name}
              />
            ) : null}
          </div>
          {loading ? (
            <TableLoadingSkeleton rows={5} columns={4} />
          ) : (
            <div className="mt-5 grid grid-cols-1 gap-3 h-full xl:grid-cols-3">
              <div className="order-2 xl:order-1 xl:col-span-2">
                <div className="card-custom p-2">
                  <CreditReturnCartonsTable
                    askDeleteCarton={askDeleteCarton}
                    updateCreditReturnItem={updateCreditReturnItem}
                    values={creditReturn}
                  />
                </div>
                <div className="flex justify-end p-4 gap-4">
                  {creditReturn ? (
                    <>
                      <p>
                        Total Cartons:{" "}
                        <span className="font-bold">
                          {creditReturn.total_cartons}
                        </span>
                      </p>
                      <p>
                        Total:{" "}
                        <span className="font-bold">
                          ${creditReturn.total_cost}
                        </span>
                      </p>
                    </>
                  ) : null}
                </div>
              </div>

              <div className="order-1 xl:order-2 xl:col-span-1 space-y-5">
                <div className="card-custom p-3 space-y-2">
                  <Input
                    label="Created By"
                    name="created_by"
                    value={creditReturn.created_by_name}
                    labelOn={true}
                    type="text"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                    disabled={true}
                  />

                  <SelectMenu
                    handleInputChange={(e) =>
                      setCreditReturn({
                        ...creditReturn,
                        customer: e.target.value,
                      })
                    }
                    name="customer"
                    options={customers}
                    value={creditReturn.customer}
                    title={"Customer"}
                    showLabel={true}
                  />

                  <Input
                    label="CR #"
                    name="credit_return_number"
                    value={creditReturn.name}
                    labelOn={true}
                    type="text"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                    disabled={true}
                  />

                  <SelectMenu
                    handleInputChange={(e) =>
                      setCreditReturn({
                        ...creditReturn,
                        status: e.target.value,
                        status_option: e.target.value,
                      })
                    }
                    name="status"
                    options={wipStatusOptions}
                    value={creditReturn.status_option}
                    title={"Status"}
                    showLabel={true}
                  />

                  <MediaUi
                    title="Document"
                    uploadedImage={pdf}
                    setUploadedImage={setPdf}
                    isEdit={true}
                    imageUrl={creditReturn.pdf_url}
                    imageName="uploaded_pdf"
                    handleInputChange={(e) =>
                      setCreditReturn({
                        ...creditReturn,
                        uploaded_pdf: e.target.value,
                      })
                    }
                    onDelete={() => {
                      setCreditReturn({
                        ...creditReturn,
                        uploaded_pdf: null,
                        pdf: "",
                        pdf_url: null,
                      });
                      setPdf(null);
                    }}
                  />

                  {!isReadOnly && (
                    <div className="mt-3 flex w-full flex-col gap-2 py-2 sm:w-auto sm:flex-row sm:items-center">
                      <ButtonDropdown
                        items={buttonOptions}
                        mainOption="Save"
                        mainAction={onSaveCr}
                      />
                      <button
                        onClick={() => {
                          askDeleteCr();
                        }}
                        className="w-full sm:w-auto rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                      >
                        Delete
                      </button>
                    </div>
                  )}
                </div>
                {creditReturn.order ? (
                  <div className="card-custom p-4">
                    <h3 className="text-sm font-semibold text-gray-900 border-b border-gray-200 pb-2 mb-4">
                      Attached order
                    </h3>
                    <Link
                      to={`/shipments/${creditReturn.order.id}`}
                      target="_blank"
                      rel="noreferrer"
                      className="block rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white text-center shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      {creditReturn.order.po_number ||
                        `Order #${creditReturn.order.id}`}
                    </Link>
                  </div>
                ) : null}
                <div className="card-custom p-3 mt-3">
                  <div className="flex justify-between">
                    <p className="text-sm text-gray-700 font-semibold">Notes</p>
                    <button
                      onClick={() =>
                        setEmptyModelOpen({
                          childComponent: (
                            <OrderNotesModal
                              orderNote={creditReturn.notes}
                              confirmAction={(newNote) =>
                                onUpdateCreditNote(newNote)
                              }
                              setOpen={setEmptyModelOpen}
                            />
                          ),
                          open: true,
                        })
                      }
                      className="text-sm font-semibold main-purple"
                    >
                      Edit
                    </button>
                  </div>
                  <p className="text-sm text-gray-700 font-normal">
                    {creditReturn.notes ? creditReturn.notes : null}
                  </p>
                </div>
              </div>
            </div>
          )}
          {creditReturnId ? (
            <EmbeddedAuditHistory
              entityId={creditReturnId}
              entityType={getAuditApiEntityType("credit-return")}
              logout={logout}
            />
          ) : null}
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OrderDetails),
);
